import {Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import withAttr from 'flarum/common/utils/withAttr';
import FormGroup from '../components/FormGroup';
import RichTextField from '../components/RichTextField';

const translationPrefix = 'kilowhat-formulaire.forum.confirmation-email-options-modal.';

interface ConfirmationEmailOptionsModalAttrs extends IInternalModalAttrs {
    title: string
    message: string
    onchange: (title: string, message: string) => void
}

export default class ConfirmationEmailOptionsModal extends Modal<ConfirmationEmailOptionsModalAttrs> {
    titleValue!: string
    message!: string

    oninit(vnode: Vnode<ConfirmationEmailOptionsModalAttrs, this>) {
        super.oninit(vnode);

        this.titleValue = this.attrs.title;
        this.message = this.attrs.message;
    }

    className() {
        return 'FormulaireModal FormulaireTheme';
    }

    title() {
        return app.translator.trans(translationPrefix + 'title');
    }

    content() {
        return m('.Modal-body', [
            m(FormGroup, {
                label: m('label', app.translator.trans(translationPrefix + 'field.title')),
            }, m('input.FormControl', {
                type: 'text',
                value: this.titleValue,
                oninput: withAttr('value', (value: string) => {
                    this.titleValue = value;
                }),
            })),
            m(FormGroup, {
                label: m('label', app.translator.trans(translationPrefix + 'field.message')),
            }, m(RichTextField, {
                value: this.message,
                onchange: withAttr('value', (value: string) => {
                    this.message = value;
                }),
            })),
            m('.Form-group', Button.component({
                type: 'submit',
                className: 'Button Button--primary',
            }, app.translator.trans(translationPrefix + 'submit'))),
        ]);
    }

    onsubmit(event: Event) {
        event.preventDefault();

        this.attrs.onchange(this.titleValue, this.message);
    }
}
